<template>
  <div class="ContactDialog" v-if="contactDialogShow">
    <div class="dialog-container">
      <div class="dialog-title">
        联系我们
        <div class="title-close-btn" @click="contactDialogShow = false"></div>
      </div>
      <div class="dialog-content">
        <div class="content-tips">请使用微信或者企业微信扫码</div>
        <div class="content-tips" style="margin-bottom: 2.5rem">联系我们</div>
        <div class="content-wechat">
          <img
            :src="`${$CdnServerAddress}websit/web/qwcode.png`"
            style="width: 100%"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/common/event-bus";

export default {
  name: "ContactDialog",
  data() {
    return {
      contactDialogShow: false,
    };
  },
  beforeDestroy() {
    EventBus.$off("openContactDialog", this.openContactDialog);
  },
  mounted() {
    EventBus.$on("openContactDialog", this.openContactDialog);
  },
  methods: {
    openContactDialog() {
      this.contactDialogShow = true;
    },
  },
};
</script>


<style lang="less" scoped>
.ContactDialog {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: #00000080;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;

  .dialog-container {
    background: #000000;
    border-radius: 8px;
    overflow: hidden;

    .dialog-title {
      background: #141414;
      font-size: 24px;
      text-align: center;
      position: relative;
      line-height: 62px;

      .title-close-btn {
        width: 16px;
        height: 16px;
        position: absolute;
        top: 50%;
        right: 40px;
        transform: translate(0, -50%);
        background: url("https://bdbcdn.bdbdigital.com/websit/web/close.png")
          no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
    }

    .dialog-content {
      padding: 37px 215px 60px;

      .content-tips {
        font-size: 18px;
        text-align: center;
        line-height: 28px;
      }

      .content-wechat {
        width: 230px;
        height: 230px;
      }
    }
  }
}
</style>